































































































































































import store from '../store'
import { linking, openLinkInBrowser } from '../mla-shared';

export default {
  data () {
    return {
      title: 'Instructions',
      openLinkInBrowser: openLinkInBrowser
    }
  },

  methods: {
    support() {
      linking({
          operation: 'openURL',
          openURL: 'mailto:tools@mla.com.au',
      });
    }
  },

  store
}
